import script from "./individual-dependants-incorporation-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./individual-dependants-incorporation-detail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__